import { render, staticRenderFns } from "./VgcArticlePikcer.vue?vue&type=template&id=4acab436&scoped=true"
import script from "./VgcArticlePikcer.vue?vue&type=script&lang=js"
export * from "./VgcArticlePikcer.vue?vue&type=script&lang=js"
import style0 from "./VgcArticlePikcer.vue?vue&type=style&index=0&id=4acab436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acab436",
  null
  
)

export default component.exports